import type { AppThemeColors } from './app-theme-palettes';
import {
  commaRgbFromHex,
  pageContrastTextColor,
  tintedSurfaceColor,
} from './ionic-color.util';

/** CSS custom properties for {@link AccordionTileComponent} surfaces. */
export function buildAccordionTileThemeVars(
  colors: AppThemeColors,
  pageBackground: string,
): Record<string, string> {
  const tileBg = tintedSurfaceColor(colors.secondary, 14, pageBackground);
  const tileBgActive = tintedSurfaceColor(colors.secondary, 20, pageBackground);
  const tileBorder = tintedSurfaceColor(colors.secondary, 28, pageBackground);
  const tileText = pageContrastTextColor(tileBgActive);

  return {
    '--app-accordion-tile-bg': tileBg,
    '--app-accordion-tile-bg-active': tileBgActive,
    '--app-accordion-tile-border': tileBorder,
    '--app-accordion-tile-text': tileText,
    '--app-accordion-tile-text-rgb': commaRgbFromHex(tileText),
  };
}
